export{ConLinkAtom}from"./ConLinkAtom.js";
